import Diversity1Icon from '@mui/icons-material/Diversity1';
import { withClarityTheme } from '@verifime/styles';
import { EntityTypeTile } from '../EntityTypeTile';

export type UnregulatedTrustTileProps = {
  /**
   * Whether this tile is currently selected
   */
  selected?: boolean;
  /**
   * Callback when the tile is clicked
   */
  onClick?: () => void;
  /**
   * Optional data-testid for testing
   */
  dataTestId?: string;
};

/**
 * UnregulatedTrustTile is a pre-configured EntityTypeTile for the Unregulated Trust entity type.
 *
 * @example
 * ```tsx
 * <UnregulatedTrustTile
 *   selected={selectedType === 'unregulated-trust'}
 *   onClick={() => setSelectedType('unregulated-trust')}
 * />
 * ```
 */
const UnregulatedTrustTileComponent = ({
  selected,
  onClick,
  dataTestId,
}: Readonly<UnregulatedTrustTileProps>) => {
  return (
    <EntityTypeTile
      icon={<Diversity1Icon />}
      // The title is copied in person-api (Greengate-Fintech/person-api), the label mapping in
      // src/main/java/com/greengate/verifime/service/notification/InviteEmailEntityData.java,
      // and sent by CustomerInvitedNotificationHandler (event/vertx). Change both together.
      title="Unregulated Trust"
      description="A trust used to hold and manage assets for family or others, not supervised by government regulators."
      hint="Choose this if you have a family trust, discretionary trust, or similar arrangement."
      selected={selected}
      onClick={onClick}
      dataTestId={dataTestId}
    />
  );
};

export const UnregulatedTrustTile = withClarityTheme(UnregulatedTrustTileComponent);
